import React, { useEffect } from 'react'
import { CCol, CWidgetDropdown, CSpinner } from '@coreui/react'
import { getStyle } from '@coreui/utils'
import { CChartLine } from '@coreui/react-chartjs'
import CIcon from '@coreui/icons-react'
import { cilArrowBottom, cilArrowTop } from '@coreui/icons'
import useAxios from 'axios-hooks'
import { VIEW_CARD_API } from 'src/views/utils/urls'

const ViewCard = ({ getDateLabels }) => {
  const [{ data: viewsData }, viewCardCall] = useAxios(
    {
      url: VIEW_CARD_API,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    viewCardCall({
      params: {
        delta_window: 30,
        unit_window: 7,
        num_data_points: 9,
      },
    })
  }, [])
  return (
    <CCol sm={6} lg={3}>
      <CWidgetDropdown
        className="mb-4"
        color="warning"
        value={viewsData?.data ? viewsData?.data.views : <CSpinner color="light" />}
        change={
          viewsData && (
            <>
              ( {Number(viewsData?.data.percentage_delta).toFixed(1)}%
              {viewsData?.data.percentage_delta > 0 ? (
                <CIcon icon={cilArrowTop} />
              ) : (
                <CIcon icon={cilArrowBottom} />
              )}
              )
            </>
          )
        }
        title="Views"
        chart={
          <CChartLine
            className="mt-3 mx-3 pb-1"
            style={{ height: '70px' }}
            data={{
              labels: getDateLabels(1, 9),
              datasets: [
                {
                  label: 'No. of Views',
                  backgroundColor: 'rgba(255,255,255,.2)',
                  borderColor: 'rgba(255,255,255,.55)',
                  pointBackgroundColor: getStyle('--cui-warning'),
                  data: viewsData?.data?.data_points,
                  fill: true,
                },
              ],
            }}
            options={{
              plugins: {
                legend: {
                  display: false,
                },
              },
              maintainAspectRatio: false,
              scales: {
                x: {
                  display: false,
                },
                y: {
                  display: false,
                },
              },
              elements: {
                line: {
                  borderWidth: 1,
                  tension: 0.4,
                },
                point: {
                  radius: 4,
                  hitRadius: 10,
                  hoverRadius: 4,
                },
              },
            }}
          />
        }
      />
    </CCol>
  )
}

export default ViewCard
